<template>
  <div class="modal-help">
     <b-modal :id="idModal" hide-footer centered @hide="handleOfModal" size="sm"> 
            <div class="modal-error">
                <div class="modal-error__head">
                <h4 class="modal-active__title font-sanpro-bold primary-color-txt font-size-20 title-error">Trợ giúp</h4>
                <span @click="$bvModal.hide(idModal)" class="modal-info__close"><i class="icon-close"></i></span>
                    <h5 class="font-size-16 primary-color-txt">Hướng dẫn sử dụng chức năng 
                      <span v-if="setRouterHelp.nameRoute === 'ebook-read-book'">"Đọc sách"</span>
                      <span v-else-if="setRouterHelp.nameRoute === 'exerciseDetail' || setRouterHelp.nameRoute === 'exerciseExamDetail' || setRouterHelp.nameRoute === 'exerciseExam'">"Luyện tập"</span>
                      <span v-else-if="setRouterHelp.nameRoute === 'DetailPageLinkLib'">"Thư viện"</span>

                    </h5>
                </div>
                <div class="modal-error__body">
                  <PreviewVideo 
                    :pathView="getHelpVideo.path ? `${appUrl}${getHelpVideo.path}` : getHelpVideo.pathView " 
                  />
                    <!-- :mediaMore="relateMedia && relateMedia.length > 0 ? true : false" -->
                    <ul class="list-help">
                        <li
                        @click="getItemHelp(item.helpId)"  v-for="(item,index) in setListHelp.list" :key="index"
                        class="list-help__item primary-color font-sanpro-semibold">
                            <a v-bind:class="{active : item.helpId == problemId}" class="css-error">{{item.name}}</a>
                        </li>
                    </ul>
                </div>
                <div class="modal-error__footer">
                    <button class="primary-color font-sanpro-semibold btn-sent" @click="openModalNotiError"><i class="icon-help-2"></i> Báo lỗi</button>
                </div>
            </div>
        </b-modal>
        <modalSolutionHelp v-if="hiddenSolutionHelp"/>
  </div>
</template>

<script>
import { ID_MODAL_SHOW_HELP } from '@/store/common/constants'
// import { ID_MODAL_ACTIVE_BOOK } from '././../../_store/constants'
import { mapState, mapActions, mapGetters } from 'vuex'
import modalSolutionHelp from "./modalSolutionHelp"
import { apiListHelp } from "@/store/common/api"
import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
import { APP_CONFIG } from '@/utils/constants'

export default {
    name: "modalShowHelp",
    data(){
      return{
        appUrl: APP_CONFIG.bookCdnUrl,
        problemId:null,
        idModal: ID_MODAL_SHOW_HELP,
        hiddenSolutionHelp: false,
        ebookType: 1,
        exType: 2,
        libType: 3,
        errorTypeId:null
      }
    },
    components:{
      modalSolutionHelp,
      PreviewVideo
    },
    computed:{
      ...mapState('common', ['loading', 'isShowModalHelp', 'setRouterHelp']),
      ...mapGetters({
          setListHelp: `common/setListHelp`,
          getHelpVideo: `common/getHelpVideo`,
          getShowVideoHelp: `common/getShowVideoHelp`,
      }),
    },
    mounted(){
       
    },
    created(){
      // if(this.setRouterHelp.nameRoute === 'ebook-read-book'){

      // if(this.setRouterHelp.nameRoute === 'exerciseDetail' || this.setRouterHelp.nameRoute === 'exerciseExamDetail'){
     
      // if(this.setRouterHelp.nameRoute === 'DetailPageLinkLib'){

    },
    watch:{
        isShowModalHelp (newVal) {
            if (newVal) {
                this.$bvModal.show(ID_MODAL_SHOW_HELP)
                if(this.getShowVideoHelp.isShowVideo === 1){
                    this.errorTypeId =1;
                    this.actionHelpGetVideo(this.ebookType)
                    this.actionListHelp({
                    typeId: 1,
                    keyword: "",
                    pageIndex: 1,
                    pageSize: 5,
                    sort: "",
                    direction: ""
                  })
                }

                if(this.getShowVideoHelp.isShowVideo === 2){
                  this.errorTypeId = 2;
                  this.actionHelpGetVideo(this.exType)
                  this.actionListHelp({
                    typeId: 2,
                    keyword: "",
                    pageIndex: 1,
                    pageSize: 5,
                    sort: "",
                    direction: ""
                  })
                }

                if(this.getShowVideoHelp.isShowVideo === 3){
                  this.errorTypeId =3;
                  this.actionHelpGetVideo(this.libType)
                  this.actionListHelp({
                    typeId: 3,
                    keyword: "",
                    pageIndex: 1,
                    pageSize: 5,
                    sort: "",
                    direction: ""
                  })
                }
            } else {
                this.$bvModal.hide(ID_MODAL_SHOW_HELP)
            }
        },
        problemId :"getItemHelp",
        
    },
    
    methods:{
        ...mapActions('common', [
        'setLoading', 
        'acToggleModaShowHelp',
        'actionListHelp',
        'actionSetIdDetaiHelp',
        'actionHelpGetVideo',
        'acToggleModaShowError'
        ]),
        getItemHelp(helpId){
            this.problemId = helpId; 
            this.actionSetIdDetaiHelp(helpId)
            this.hiddenSolutionHelp = true
            this.$bvModal.show('modalSolutionHelp')
        },
        handleOfModal () {
            this.acToggleModaShowHelp(false)
      },
      openModalNotiError(){
        this.acToggleModaShowError({isShow:true,errorTypeId: this.errorTypeId})
        this.$bvModal.hide(ID_MODAL_SHOW_HELP)
      }
    }
}
</script>

<style lang="scss" scoped>
.btn-close {
    border: 0;
    background: #fff;
    top: 5px;
    right: 7px;
    position: absolute;
    border-radius: 20px;
    .icon-close {
        height: 12px;
        width: 12px;
    }
}
img {
    max-width: 100%;
    height: auto;
}
.title-error{
    margin-bottom: 15px;
}
.modal-error{
    padding: 15px;
    background: #fff;
    border-radius: 10px;
    &__head{

    }
    &__body{
        .list-help{
          margin-top: 20px;
            padding: 0;
            &__item{
                list-style-type: none;
                border-radius: 8px;
                cursor: pointer;
                margin-bottom: 5px;
                .css-error{
                    padding: 12px 15px;
                    width: 100%;
                    display: block;
                    border-radius: 8px;
                }
            }
        }
        .other-problem{
            label{
                padding-left: 15px;
            }
            .css-textarea{
                background: #F3F6FB;
                border-radius: 8px;
                border: 0;
                resize: none;
                padding: 10px 15px;
                width: 100%;
            }
        }
    }
    &__footer{
        margin-top: 10px;
        text-align: right;
        .btn-sent{
            position: relative;
            background: #F3F6FB;
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
            width: 105px;
            border: 0;
            outline: 0;
            i{
              margin-right: 5px;
            }
        }
    }
}
.active{
    background: #E1EFFF;
}
</style>